import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  openDrawer: true,
  unreadMessagesCount: 0,
};

export const basicSlice = createSlice({
  name: "basic",
  initialState,
  reducers: {
    setDrawer: (state, action) => {
      state.openDrawer = action.payload;
    },
    setUnreadMessagesCount: (state, action) => {
      state.unreadMessagesCount = action.payload;
    },
  },
});

export const { setDrawer, setUnreadMessagesCount } = basicSlice.actions;

export default basicSlice.reducer;
